import moment from 'moment'
import { useEffect } from 'react'
import { useState } from 'react'
import { memo } from 'react'
import { useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setCurrentPlayTime } from 'redux/actions/reactorActions'
import '../../styles/customize-progress-bar.css'

const ProgressBar = ({ mediaRef, mediaDuration }) => {
    const { currentPlayTime } = useSelector(state => state.reactor)
    const { playListIndex } = useSelector(state => state.harmonize)
    const { playList } = useSelector(state => state.messages)
    const { preview } = useSelector(state => state.playerControls)
    const [portrait, setIsPortrait] = useState(window.innerWidth > window.innerHeight ? false : true)
    const dispatch = useDispatch()
    const progressBarRef = useRef()
    const getPositions = () => {
        const song = playList[playListIndex]
        const highlightTime = song ? song.highlightTime : 0
        const startPosition = preview && highlightTime ? highlightTime : 0
        const endPosition = preview ? startPosition + parseInt(process.env.REACT_APP_AUDIO_PREVIEW_LENGTH) : 0
        return { startPosition, endPosition }
    }
    const handleProgressChange = () => {
        if (mediaRef.current && progressBarRef.current) {
            const { startPosition, endPosition } = getPositions()
            const newTime = Number(progressBarRef.current.value)
            console.log(`handleProgressChange ${newTime} start ${startPosition} end ${endPosition}`)
            if (newTime >= startPosition && (endPosition === 0 || newTime <= endPosition)) {
                mediaRef.current.currentTime = newTime
                dispatch(setCurrentPlayTime(newTime))
                progressBarRef.current.style.setProperty(
                    '--range-progress',
                    `${(newTime / mediaDuration) * 100}%`
                )
            }
        }
    }

    const formatTime = (time) => {
        if (typeof time === 'number' && !isNaN(time)) {
            const displayTime = moment.duration(time, 'seconds')
            return displayTime.format(time >= 60 ? 'm:ss' : '0:ss')
        }
        return '0:00'
    }

    /**
     * Track orientation change to get this bar out of the way of the left and right
     * Overlay controls in landscape mode.
     */
    useEffect(() => {

        const handleOrientationChange = () => {
            console.log(`ProgressBar orientation change ${window.screen.orientation.type}`)
            setIsPortrait(window.screen.orientation.type.startsWith('portrait'))
        }
        window.screen.orientation.addEventListener('change', handleOrientationChange)
        return () => {
            window.screen.orientation.removeEventListener('change', handleOrientationChange)
        }
    }, [])

    useEffect(() => {
        progressBarRef.current.style.setProperty(
            '--range-progress',
            `${(currentPlayTime / mediaDuration) * 100}%`
        )
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPlayTime])
    return (
        <div className="flex items-center justify-center gap-5 w-full"
            style={{
                color: 'yellow',
                display: 'flex', alignItems: 'center',
                paddingLeft: portrait ? '0' : '6vw',
                paddingRight: portrait ? '0' : '6vw'
            }}>
            <span>{formatTime(currentPlayTime)}</span>
            <input
                className="max-w-[80%] bg-gray-300"
                ref={progressBarRef}
                max={mediaDuration ? mediaDuration : 0}
                type="range"
                defaultValue="0"
                onChange={handleProgressChange}
            />
            <span>{formatTime(mediaDuration)}</span>
        </div>
    )
}

export default memo(ProgressBar)